import {
  createSelectorWithProps,
  createSimpleSelector,
  createSingleEntityStore,
} from '@recruitee/ngrx';

import { EntityStoreKey, FeatureFlag, FeatureFlagsMap } from '../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<FeatureFlag[]>()(
  EntityStoreKey.featureFlags,
  {
    customActions: adapter => ({
      init: (state, payload: FeatureFlag[]) => adapter.save(state, payload),
    }),
  },
);

const selectFeatureMap = createSimpleSelector(selectors.data, featureFlags =>
  Object.values(FeatureFlag).reduce((acc, value) => {
    acc[value] = (featureFlags || []).includes(value);
    return acc;
  }, <FeatureFlagsMap>{}),
);

const FeatureFlagSelectors = {
  ...selectors,
  map: selectFeatureMap,
  featureEnabled: createSelectorWithProps(
    selectFeatureMap,
    (featureFlagsMap: FeatureFlagsMap, feature: FeatureFlag) => featureFlagsMap[feature],
  ),
};

export {
  actions as FeatureFlagEntityActions,
  reducer as FeatureFlagReducer,
  namespace as FeatureFlagNamespace,
  FeatureFlagSelectors,
};
